//@ts-check
import produce from 'immer';
import ACTIONS from '../../actions';
var initialState = [];
export var modalReducer = function modalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.MODAL_OPEN:
      {
        var nextState = produce(state, function (draft) {
          draft.push({
            type: action.payload.modalType,
            props: action.payload.modalProps
          });
        });
        return nextState;
      }

    case ACTIONS.MODAL_CLOSE:
      {
        if (!state.length) return state;

        var _nextState = produce(state, function (draft) {
          draft.pop();
        });

        return _nextState;
      }

    default:
      return state;
  }
};
export default modalReducer;